export default __webpack_public_path__ + "static/media/news34.2445ec61.jpg";